import type {
    WithRequestedChangeFileds,
    WithFieldsStatuses,
    WithFieldsComments
} from "features/onboarding/types";
import type { useForm } from "hooks";
import type { Moment } from "moment";
import type { BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/Onboarding/shared";

export const enum FormField {
    CompanyName = 'companyName',
    RegistrationNumber = 'registrationNumber',
    CountryOfIncorporation = 'countryOfIncorporation',
    YearEstablished = 'yearEstablished',
    WebsiteUrl = 'websiteUrl',
    PrimaryLocation = 'primaryLocation',
    CountriesOfBusinessActivity = 'countriesOfBusinessActivity',
    Platforms = 'platforms'
};

export type OnboardingBusinessInformation =
    & WithFieldsStatuses
    & WithFieldsComments
    & WithRequestedChangeFileds
    & {
        readonly [FormField.CompanyName]: string;
        readonly [FormField.RegistrationNumber]: string;
        readonly [FormField.CountryOfIncorporation]: string | null;
        readonly [FormField.YearEstablished]: Moment | null;
        readonly [FormField.WebsiteUrl]: string;
        readonly [FormField.PrimaryLocation]: string;
        readonly [FormField.Platforms]: Array<string>;
        readonly [FormField.CountriesOfBusinessActivity]: Array<string>;
    };

export type OnboardingBusinessInformationBootstrapData = {};

export type OnboardingBusinessInformationForm = Omit<
    BootstrapableForm<OnboardingBusinessInformation, OnboardingBusinessInformationBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingBusinessInformation;
};

export type OnboardingBusinessInformationProps =
    & OnboardingFormProps
    & OnboardingBusinessInformationForm
    & ReturnType<typeof useForm<OnboardingBusinessInformation>>;
